module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main-contract-number-tag"
  }, [_c('div', {
    class: [!_vm.isIframe ? 'title' : 'isIframe']
  }, [(!_vm.isIframe) ? _c('span', {
    style: ({
      float: 'left',
      paddingRight: '20px'
    })
  }, [_vm._v("主合同号标签配置")]) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      float: 'left',
      padding: '0 10px 0px 10px',
    })
  }, [(_vm.isOppein) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    style: ({
      float: 'right',
      paddingRight: '10px'
    })
  }, [_c('el-form', {
    ref: "searchForm",
    staticClass: "search-form-tag",
    staticStyle: {
      "display": "inline-block",
      "width": "380px"
    },
    attrs: {
      "model": _vm.searchForm,
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "margin-bottom": "0"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商场编码",
      "size": "mini"
    },
    model: {
      value: (_vm.searchForm.orgNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orgNo", $$v)
      },
      expression: "searchForm.orgNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "margin-bottom": "0"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "取号门店编码/组织编码",
      "size": "mini"
    },
    model: {
      value: (_vm.searchForm.no),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "no", $$v)
      },
      expression: "searchForm.no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("搜索")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('table-select-all', {
    ref: "selectTable",
    staticClass: "detal-table",
    attrs: {
      "selectable": false,
      "byKey": "productId",
      "tableData": _vm.tableData,
      "initData": _vm.getCustomerMainContactLabelQueryPage,
      "maxHeight": null,
      "emptyText": "暂无数据"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orgNo",
      "label": "商场编码",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orgId ? _vm.orgIdMap[scope.row.orgId] : scope.row.orgNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "no",
      "label": "取号门店/商场编码",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "取号门店/商场",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "品牌品类",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.brandName) + _vm._s(scope.row.categoryName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": "主合同号标签",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastUpdator",
      "label": "最后更新人",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastUpdateDt",
      "label": "最后修改时间",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("dateFormat")(scope.row.lastUpdateDt, "yyyy-MM-dd HH:mm:ss")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastUpdateDt",
      "label": "操作",
      "min-width": "250",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row, 'edit')
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.no !== _vm.currentUser.orgNo) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row, 'view')
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "edit-dialog-tag",
    attrs: {
      "title": "主合同号取号标签",
      "visible": _vm.editDialogVisible,
      "width": "800px",
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticClass: "edit-dialog-form",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editRules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "取号标签配置维度"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.dialogEdit
    },
    on: {
      "change": _vm.handleRadioChange
    },
    model: {
      value: (_vm.editForm.radio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "radio", $$v)
      },
      expression: "editForm.radio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("商场")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("门店")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 20px 0 0",
      "border": "1px solid #e4e7ed"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商场编码",
      "prop": "orgNo"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.isOppein && _vm.editType !== 'edit' ? 16 : 24
    }
  }, [_c('el-input', {
    class: [{
      'get-org-btn': _vm.isOppein && _vm.editType !== 'edit'
    } ],
    attrs: {
      "size": "small",
      "width": "128px",
      "disabled": !_vm.isOppein || _vm.editType === 'edit'
    },
    model: {
      value: (_vm.editForm.orgNo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "orgNo", $$v)
      },
      expression: "editForm.orgNo"
    }
  })], 1), _vm._v(" "), (_vm.isOppein && _vm.editType !== 'edit') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.isOppein && _vm.editType !== 'edit') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.selectOrgByNo
    }
  }, [_vm._v("确定")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "取号门店/商场",
      "prop": "no",
      "label-width": "120px"
    }
  }, [_c('OrganizationSelect', {
    ref: "orgSelect",
    attrs: {
      "placeholder": "请选择取号门店/商场",
      "value": _vm.editForm.id,
      "orgId": _vm.editForm.orgId,
      "disabled": _vm.editForm.radio === 1 || _vm.dialogEdit,
      "multiple": false,
      "white": "shop"
    },
    on: {
      "onNodeClick": function (data) {
        _vm.onNodeClick(data);
      },
      "onCheckChange": function (data) {
        _vm.onCheckChange(data);
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "取号门店/商场编码"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "取号门店/商场编码"
    },
    model: {
      value: (_vm.editForm.no),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "no", $$v)
      },
      expression: "editForm.no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "取号标签",
      "prop": "label",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入取号标签（最多10个字符）",
      "maxlength": "10",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.editForm.label),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "label", $$v)
      },
      expression: "editForm.label"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌品类"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "small",
      "disabled": _vm.disabledBrandCategory || _vm.dialogEdit,
      "placeholder": "请选择品牌品类"
    },
    on: {
      "change": _vm.handleBrandCategoryChange,
      "visible-change": _vm.loadBrandCategoryList
    },
    model: {
      value: (_vm.editForm.brandCategoryList),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "brandCategoryList", $$v)
      },
      expression: "editForm.brandCategoryList"
    }
  }, _vm._l((_vm.brandCategoryList), function(category) {
    return _c('el-option', {
      key: category.value,
      attrs: {
        "label": category.label,
        "value": category.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("不选择品牌品类则默认为全品类")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.editType !== 'view') ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelEditDialog
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditForm
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3174ab52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/mainContractNumberTag.vue
// module id = 2414
// module chunks = 68